import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthenticationGuard } from '@sla-ng/core';

const routes: Routes = [
    {
        path: 'landing',
        loadChildren: () => import('./pages/landing/landing-page.module').then(m => m.LandingPageModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'master-data/measure-unit',
        loadChildren: () => import('./pages/lazy/lazy-measure-unit.module').then(m => m.LazyMeasureUnitModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'master-data/reference-size',
        loadChildren: () => import('./pages/lazy/lazy-reference-size.module').then(m => m.LazyReferenceSizeModule),
        canActivate: [ AuthenticationGuard ],
        canLoad: [ AuthenticationGuard ],
    },
    {
        path: 'master-data/cost-center',
        loadChildren: () => import('./pages/lazy/lazy-cost-center.module').then(m => m.LazyCostCenterModule),
        canActivate: [ AuthenticationGuard ],
        canLoad: [ AuthenticationGuard ],

    },
    {
        path: 'master-data/contribution-margin-level',
        loadChildren: () => import('./pages/lazy/lazy-contribution-margin-level.module').then(m => m.LazyContributionMarginLevelModule),
        canActivate: [ AuthenticationGuard ],
        canLoad: [ AuthenticationGuard ],

    },
    {
        path: 'master-data/cost-type',
        loadChildren: () => import('./pages/lazy/lazy-cost-type.module').then(m => m.LazyCostTypeModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },

    {
        path: 'master-data/join-cost-type-cost-center',
        loadChildren: () => import('./pages/lazy/lazy-join-cost-type-cost-center.module').then(m => m.LazyJoinCostTypeCostCenterModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'master-data/join-cost-center-cost-unit',
        loadChildren: () => import('./pages/lazy/lazy-join-cost-center-cost-unit.module').then(m => m.LazyJoinCostCenterCostUnitModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'master-data/cost-unit',
        loadChildren: () => import('./pages/lazy/lazy-cost-unit.module').then(m => m.LazyCostUnitModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'master-data/cost-unit-group',
        loadChildren: () => import('./pages/lazy/lazy-cost-unit-group.module').then(m => m.LazyCostUnitGroupModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'master-data/costing-levels',
        loadChildren: () => import('./pages/lazy/lazy-costing-levels.module').then(m => m.LazyCostingLevelsModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'master-data/bab-definition',
        loadChildren: () => import('./pages/lazy/lazy-join-cost-center-cost-center.module').then(m => m.LazyJoinCostCenterCostUnitModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'master-data/cost-accounting-type',
        loadChildren: () => import('./pages/lazy/lazy-cost-accounting-type.module').then(m => m.LazyCostAccountingTypeModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'external-data/moving-average-price',
        loadChildren: () => import('./pages/lazy/lazy-moving-average-price.module').then(m => m.LazyMovingAveragePriceModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'external-data/production-version',
        loadChildren: () => import('./pages/lazy/lazy-production-version.module').then(m => m.LazyProductionVersionModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],

    },
    {
        path: 'external-data/production-version/:productionVersionId',
        loadChildren: () => import('./pages/lazy/lazy-production-version-detail.module').then(m => m.LazyProductionVersionDetailModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'external-data/purchase',
        loadChildren: () => import('./pages/lazy/lazy-purchase.module').then(m => m.LazyPurchaseModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'external-data/sale',
        loadChildren: () => import('./pages/lazy/lazy-sale.module').then(m => m.LazySaleModule),
        canActivate: [ AuthenticationGuard ],
        canLoad: [ AuthenticationGuard ],
    },
    {
        path: 'external-data/time-record',
        loadChildren: () => import('./pages/lazy/lazy-time-record.module').then(m => m.LazyTimeRecordModule),
        canActivate: [ AuthenticationGuard ],
        canLoad: [ AuthenticationGuard ],

    },
    {
        path: 'external-data/cost',
        loadChildren: () => import('./pages/lazy/lazy-cost.module').then(m => m.LazyCostModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'external-data/planned-sale-price',
        loadChildren: () => import('./pages/lazy/lazy-planned-sale-price.module').then(m => m.LazyPlannedSalePriceModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'external-data/article-costing-level',
        loadChildren: () => import('./pages/lazy/lazy-costinglevel-article-mapping.module').then(m => m.LazyCostinglevelArticleMappingModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'external-data/working-plan',
        loadChildren: () => import('./pages/lazy/lazy-working-plan.module').then(m => m.LazyWorkingPlanModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'external-data/article',
        loadChildren: () => import('./pages/lazy/lazy-article.module').then(m => m.LazyArticleModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'external-data/production',
        loadChildren: () => import('./pages/lazy/lazy-production.module').then(m => m.LazyProductionModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'external-data/production/:productionOrderNr',
        loadChildren: () => import('./pages/lazy/lazy-production-detail.module').then(m => m.LazyProductionDetailModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'planning/planned-purchase-price',
        loadChildren: () => import('./pages/lazy/lazy-planned-purchase-price.module').then(m => m.LazyPlannedPurchasePriceModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'planning/planned-sale-volume',
        loadChildren: () => import('./pages/lazy/lazy-planned-sale-volume.module').then(m => m.LazyPlannedSaleVolumeModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'cost-accounting',
        loadChildren: () => import('./pages/lazy/lazy-cost-accounting.module').then(m => m.LazyCostAccountingModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },
    {
        path: 'cost-unit-cost',
        loadChildren: () => import('./pages/lazy/lazy-cost-unit-cost.module').then(m => m.LazyCostUnitCostModule),
        canLoad: [ AuthenticationGuard ],
        canActivate: [ AuthenticationGuard ],
    },

    { path: '', redirectTo: 'landing', pathMatch: 'full' },

];

@NgModule({
    imports: [ RouterModule.forRoot(routes, { useHash: true }),
        RouterModule.forChild(routes) ],
    exports: [ RouterModule ],
})
export class AppRoutingModule {
}
